module.exports = __webpack_public_path__ + "assets/img/img232.a99c2003.png";